class HelperCheckboard {
  render = (white, grey, size, ServerCanvas) => {
    if (typeof document === 'undefined' && !ServerCanvas) {
      return null;
    }

    const canvas = ServerCanvas
      ? new ServerCanvas()
      : document.createElement('canvas');

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    canvas.width = size * 2;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    canvas.height = size * 2;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      return null;
    }

    ctx.fillStyle = white;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = grey;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);

    return canvas.toDataURL();
  };

  get = (white, grey, size, serverCanvas) => {
    const checkboardCache = {};
    const key = `${white}-${grey}-${size}${serverCanvas ? '-server' : ''}`;
    const checkboard = this.render(white, grey, size, serverCanvas);

    if (checkboardCache[key]) {
      return checkboardCache[key];
    }

    checkboardCache[key] = checkboard;

    return checkboard;
  };
}

export default new HelperCheckboard();
